"use strict";

const codes = [
  {
    label: "i",
    mobileLabel: "One",
    code: 1,
    level: 1
  },
  {
    label: "ii",
    mobileLabel: "Two",
    code: 2,
    level: 1
  },
  {
    label: "iii",
    mobileLabel: "Three",
    code: 3,
    level: 1
  },
  {
    label: "iv",
    mobileLabel: "Four",
    code: 4,
    level: 2
  },
  {
    label: "v",
    mobileLabel: "Five",
    code: 5,
    level: 2
  },
  {
    label: "vi",
    mobileLabel: "Six",
    code: 6,
    level: 2
  },
  {
    label: "vii",
    mobileLabel: "Seven",
    code: 7,
    level: 2
  },
  {
    label: "viii",
    mobileLabel: "Eight",
    code: 8,
    level: 2
  },
  {
    label: "ix",
    mobileLabel: "Nine",
    code: 9,
    level: 3
  },
  {
    label: "x",
    mobileLabel: "Ten",
    code: 10,
    level: 3
  },
  {
    label: "xi",
    mobileLabel: "Eleven",
    code: 11,
    level: 3
  },
  {
    label: "xii",
    mobileLabel: "Twelve",
    code: 12,
    level: 3
  }
];

module.exports = codes.map((c) => {
  return Object.assign({}, c, { label: c.label.toUpperCase() });
});
